import { render, staticRenderFns } from "./group-relationship-mana.vue?vue&type=template&id=d157e684&scoped=true"
import script from "./group-relationship-mana.vue?vue&type=script&lang=js"
export * from "./group-relationship-mana.vue?vue&type=script&lang=js"
import style0 from "./group-relationship-mana.vue?vue&type=style&index=0&id=d157e684&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d157e684",
  null
  
)

export default component.exports